export const getMonth = (date: string) => {
    const [year, month] = date.split('-');
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ];
    return `${months[parseInt(month, 10) - 1]}, ${year}`;
};

